import Point from './Point';
import IBoundingBox from './IBoundingBox';
import MathUtils from './MathUtils';

export type RectVertice = "LT" | "RT" | "LB" | "RB";

export default class Rect implements IBoundingBox {
	readonly left:number;
	readonly right:number;
	readonly top:number;
	readonly bottom:number;
	readonly angle:number;
	readonly center:Point;

	constructor(left:number, right:number, top:number, bottom:number, angle:number = 0){
		this.left = left;
		this.right = right;
		this.top = top;
		this.bottom = bottom;
		this.angle = angle;
		this.center = new Point(left + (right - left) / 2, top + (bottom - top) / 2);
	}

	public getVertice = (vertice:RectVertice):Point => {
		switch (vertice) {
			case "LT": return (new Point(this.left, this.top)).rotate(this.center, this.angle);
			case "RT": return (new Point(this.right, this.top)).rotate(this.center, this.angle);
			case "LB": return (new Point(this.left, this.bottom)).rotate(this.center, this.angle);
			case "RB": return (new Point(this.right, this.bottom)).rotate(this.center, this.angle);
		}
	}

	public getArea = ():number => {
		return (this.right - this.left) * (this.bottom - this.top);
	}

	public hit = (target:Point):boolean => {
		let triangleArea = [
			MathUtils.triangleArea(
				MathUtils.distance(target, this.getVertice('LT')),
				MathUtils.distance(this.getVertice('LT'), this.getVertice('RT')),
				MathUtils.distance(this.getVertice('RT'), target)
			),
			MathUtils.triangleArea(
				MathUtils.distance(target, this.getVertice('RT')),
				MathUtils.distance(this.getVertice('RT'), this.getVertice('RB')),
				MathUtils.distance(this.getVertice('RB'), target)
			),
			MathUtils.triangleArea(
				MathUtils.distance(target, this.getVertice('RB')),
				MathUtils.distance(this.getVertice('RB'), this.getVertice('LB')),
				MathUtils.distance(this.getVertice('LB'), target)
			),
			MathUtils.triangleArea(
				MathUtils.distance(target, this.getVertice('LB')),
				MathUtils.distance(this.getVertice('LB'), this.getVertice('LT')),
				MathUtils.distance(this.getVertice('LT'), target)
			)
		];

		let triangleAreaSum = triangleArea.reduce((a:number, b:number) => { return a + b; }, 0);

		return Math.round(triangleAreaSum) <= Math.round(this.getArea());
	}
}